import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import Logo from "../components/Logo";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true, state: { user: data } });
      } catch (e) {
        setError(e?.response?.data?.detail || "Login failed");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div data-testid="auth-callback" className="min-h-screen flex flex-col items-center justify-center gap-6">
      <Logo />
      {error ? (
        <p data-testid="auth-callback-error" className="text-red-400 text-sm">{error}</p>
      ) : (
        <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-400">Signing you in…</p>
      )}
    </div>
  );
}
